import { render } from "./comparison-list.vue?vue&type=template&id=467869cb"
import script from "./comparison-list.vue?vue&type=script&lang=js"
export * from "./comparison-list.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__